import type { DrillDownState } from 'client/js/redux/domains/DrillDown/DrillDown.types';

export const INIT_STATE: DrillDownState = {
  data: {},
};
